module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"AI着用画像のご案内","description_title":"着用画像をアップロードしてみましょう","description_content":"写真を添付すると、AI分析を通じて着用画像かどうかを判別します。商品を着用した状態で、身体の部位（目、鼻、口、腕、足、腰など）が写っている写真をアップロードしてください。","disclaimer":"*AI分析モデルで判定しているため、分析結果に誤差が生じる場合があります。"}}')
  delete Component.options._Ctor
}
